var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home texture-bg-css"},[_c('Carousels'),_c('Introduce'),_c('Cooperation'),_c('News')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }